var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notification_svg__clip0_61183_6458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.942 12.058l-1.692-1.692V8.125a6.258 6.258 0 00-5.625-6.218V.625h-1.25v1.282A6.258 6.258 0 003.75 8.125v2.241l-1.692 1.692a.625.625 0 00-.183.442v1.875A.625.625 0 002.5 15h4.375v.486a3.22 3.22 0 002.813 3.249 3.129 3.129 0 003.437-3.11V15H17.5a.624.624 0 00.625-.625V12.5a.625.625 0 00-.183-.442zm-6.067 3.567a1.875 1.875 0 11-3.75 0V15h3.75v.625zm5-1.875H3.125v-.991l1.692-1.692A.625.625 0 005 10.625v-2.5a5 5 0 1110 0v2.5c0 .166.066.325.183.442l1.692 1.692v.991z",
    fill: "#45464F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notification_svg__clip0_61183_6458"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgNotification;